import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';

import { getLineNumber } from './bankCsvImportUtils';

export default function BankCsvEditDialog({
    open,
    editingRow,
    editedPurpose,
    onPurposeChange,
    onClose,
    onSave,
}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Fehlerhaften Datensatz bearbeiten</DialogTitle>
            <DialogContent>
                {editingRow && (
                    <Stack spacing={2} sx={{ pt: 1 }}>
                        <TextField
                            label="Verwendungszweck"
                            fullWidth
                            multiline
                            rows={4}
                            value={editedPurpose}
                            onChange={(event) => onPurposeChange(event.target.value)}
                            helperText={`Zeile ${getLineNumber(editingRow, editingRow.originalIndex)}`}
                        />
                        <Alert severity="error">{editingRow.errors.join('; ')}</Alert>
                    </Stack>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button onClick={onSave} variant="contained">
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}
